import { CalendarDays, ReceiptText, Settings2, ShieldCheck, TrendingUp } from 'lucide-react';
import type { ModuleNav } from '@/components/layout/module-nav';

/**
 * Catering's navigation: gastronomy's Dziś, Wyniki and Kontrola, for the
 * canteens, and the month's Rozliczenie with `canSettleCatering`.
 *
 * Settings are open to everyone who sees catering and read-only without
 * `canEditCateringSettings`. A site's collector token is its data source's, on
 * Administracja → Źródła danych.
 */
export const CATERING_NAV: ModuleNav = {
  left: [
    [
      { to: '/catering', labelKey: 'catering.nav.today', icon: CalendarDays },
      { to: '/catering/results', labelKey: 'catering.nav.results', icon: TrendingUp },
      { to: '/catering/controls', labelKey: 'catering.nav.controls', icon: ShieldCheck },
      { to: '/catering/settlement', labelKey: 'catering.nav.settlement', icon: ReceiptText, capability: 'canSettleCatering' },
    ],
  ],
  right: [{ to: '/catering/settings', labelKey: 'catering.nav.settings', icon: Settings2 }],
};
